import { render, staticRenderFns } from "./language-items-secondary.vue?vue&type=template&id=0bef953f&scoped=true"
import script from "./language-items-secondary.vue?vue&type=script&lang=js"
export * from "./language-items-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bef953f",
  null
  
)

export default component.exports